var React = require('react');

function LocationIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.4961 3.08434L3.6608 9.71042C2.76548 10.0881 2.78705 11.3615 3.68237 11.7069L9.44262 13.9408C9.72308 14.0487 9.94961 14.2753 10.0575 14.5559L12.2796 20.3078C12.6248 21.2143 13.9084 21.2359 14.286 20.3402L20.92 4.50884C21.2759 3.61313 20.3806 2.71742 19.4961 3.08434Z","fill":"#53647F"}));
}

LocationIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = LocationIcon;

LocationIcon.default = LocationIcon;
